export const msgIdPrefix = 'ku-block-sdk-';
export const API_REQUEST_TYPE = 'ku-block-api-request';
export const API_RESPONSE_TYPE = 'ku-block-api-response';
export const EVENT_REGISTER_TYPE = 'ku-block-event-register';
export const EVENT_RESPONSE_TYPE = 'ku-block-event-response';

export enum ErrorCode {
    CanNotUse = 10001, // API 不可用
}

/** 调试环境固定工具 ID */
export const devToolId = '__dev_tool__';

export const VersionOfCreateServiceExtensionVersion = '2';
